import { AbstractGoMoveGenerator } from '../AbstractGoMoveGenerator';
import { TriangularGoRules } from './TriangularGoRules';
export class TriangularGoMoveGenerator extends AbstractGoMoveGenerator {
    constructor() {
        super(TriangularGoRules.get());
    }
}
